
import React, { useState, useEffect, useRef } from 'react';

const QUOTES = [
  "const arcade = new NiftyArcade();",
  "function deploy() { return success; }",
  "import { engagement } from 'retro-games';",
  "git commit -m 'Release the archive'",
  "while (isAwesome) { play(); }",
  "sudo apt-get install fun"
];

const Typing: React.FC = () => {
  const [quote, setQuote] = useState("");
  const [input, setInput] = useState("");
  const [startTime, setStartTime] = useState<number | null>(null);
  const [wpm, setWpm] = useState(0);

  useEffect(() => {
    setQuote(QUOTES[Math.floor(Math.random() * QUOTES.length)]);
  }, []);

  const handleChange = (val: string) => {
    if (!startTime) setStartTime(Date.now());
    setInput(val);
    if (val === quote) {
      const time = (Date.now() - startTime!) / 1000 / 60;
      setWpm(Math.round(quote.split(' ').length / time));
      setTimeout(() => {
        setQuote(QUOTES[Math.floor(Math.random() * QUOTES.length)]);
        setInput("");
        setStartTime(null);
      }, 1000);
    }
  };

  return (
    <div className="max-w-xl w-full flex flex-col items-center">
      <div className="mb-12 text-center">
        <p className="text-3xl font-mono text-blue-400 mb-4">{quote}</p>
        <input
          type="text"
          value={input}
          onChange={(e) => handleChange(e.target.value)}
          className="bg-slate-900 border-2 border-slate-800 p-4 w-full rounded-xl text-xl font-mono focus:border-blue-500 outline-none"
          placeholder="Start coding..."
        />
      </div>
      <div className="text-4xl font-black text-slate-100">{wpm} <span className="text-sm text-slate-500 uppercase tracking-widest">WPM</span></div>
    </div>
  );
};

export default Typing;
